import { createClient } from '@supabase/supabase-js'
import { supabaseAnonKey, supabaseUrl } from './supabaseEnv'

/**
 * Separate Supabase client for storefront buyer sessions.
 *
 * Uses a distinct `storageKey` so buyer tokens are stored under a different
 * localStorage key ('buyer-sf-auth-token') from the seller client
 * ('sb-<ref>-auth-token'). Logging out a buyer never touches the seller session
 * and vice-versa.
 */
export const buyerSupabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false, // seller client handles OAuth callbacks
    storageKey: 'buyer-sf-auth-token',
  },
})
